import { render, staticRenderFns } from "./nav-setting.vue?vue&type=template&id=cacb913c&scoped=true"
import script from "./nav-setting.vue?vue&type=script&lang=js"
export * from "./nav-setting.vue?vue&type=script&lang=js"
import style1 from "./nav-setting.vue?vue&type=style&index=1&id=cacb913c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cacb913c",
  null
  
)

export default component.exports